let navigate;

export const setNavigator = (nav) => {
  navigate = nav;
}

export  async function fetchWrapper (URL, option = {}) {
  const res = await fetch(URL, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...option
  })
  
  if(res.status === 401) navigate("admin")
  return res.json();
}

